//
// Wrapper around axios to include Rails CSRF token and token to
// access the API.
//
import axios from 'axios';
import qs from 'qs';
import unauthorizedApiResponseHandler from '../utilities/unauthorized_api_response_handler';

const csrfToken = document.querySelector('[name="csrf-token"]') || { content: 'no-csrf-token' };

const AxiosApiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    common: {
      'X-CSRF-Token': csrfToken.content
    }
  }
});

AxiosApiClient.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
      encode: false
    });
  };

  const apiToken = document.querySelector('[name="api-token"]');
  if (apiToken && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${apiToken.content}`;
  }

  return config;
});

AxiosApiClient.interceptors.response.use(response => { return response; }, error => {
  if (error.response.status == 401) {
    return unauthorizedApiResponseHandler(error, AxiosApiClient);
  }
  return Promise.reject(error);
});

class RefreshTokenExpiredError extends Error {
  constructor(message) {
    super(message);
    this.name = "RefreshTokenExpiredError";
  }
}

class ApiRequestError extends Error {
  constructor(message) {
    super(message);
    this.name = "ApiRequestError";
  }
}

export { AxiosApiClient,  RefreshTokenExpiredError, ApiRequestError };
